import * as React from "react";

import { string, bool, node } from "prop-types";

import { cn } from "@/components/utils";
import { LoaderCircle } from "lucide-react";
import withValidation from "../../hocs/withValidation";

let Input = React.forwardRef(
  (
    { className, type, isLoading, validation, hint, label, id, ...props },
    ref,
  ) => {
    const generatedId = React.useId();
    const inputId = id ?? (label ? generatedId : undefined);

    return (
      <div className="w-full">
        {label && (
          <label htmlFor={inputId} className="mb-1 font-semibold">
            {label}
          </label>
        )}
        {hint && <Hint>{hint}</Hint>}
        <div className="relative">
          <input
            id={inputId}
            type={type}
            className={cn("input-field", validation.className, className)}
            ref={ref}
            {...props}
          />
          {isLoading && (
            <div className="text-muted-foreground pointer-events-none absolute top-0 flex h-full w-full items-center justify-end pe-2">
              <LoaderCircle size={16} className="animate-spin" />
            </div>
          )}
        </div>
        {validation.elements}
      </div>
    );
  },
);

Input.propTypes = {
  className: string,
  type: string,
  isLoading: bool,
  hint: node,
};

Input.displayName = "Input";

const Hint = ({ children }) => (
  <p className="text-muted-foreground mb-2">{children}</p>
);

Input = withValidation()(Input);

export { Input, Hint };
